import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {store} from 'base/reducers';
import CONFIG from 'base/constants/config';
import {UploadImage} from 'components/UI/Image';
import {HomeBanners} from 'api';
import {connect} from 'react-redux';

class HomeBannerBox extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleDelete = this.handleDelete.bind(this);
    this.goEdit = this.goEdit.bind(this);

  }

  handleDelete() {
    const id = this.props.data && this.props.data.id;
    if (!id) {
      return;
    }
    if (confirm("Bạn có muốn xóa banner này không?")) {
      HomeBanners.actions.delete.request({id}).then(response => {
        this.props.dispatch({
          type: 'REMOVE_HOME_BANNER',
          homeBannerId: id
        });
      });
    }
  }

  goEdit() {
    const id = this.props.data && this.props.data.id;
    if (!id) {
      return;
    }
    this.props.history.push(`/home-banners/edit/${id}`);
  }

  render() {
    let Img = null;
    if (this.props.data && this.props.data.image) {
      Img = <UploadImage width={250} height={250} type='HOME_BANNER' image={this.props.data.image} transform='crop' className="image"/>
    } else {
      Img = <img className="media-object" src={require('assets/images/placeholder-128.jpg')} alt="..." width="250" height="250" className="image"/>;
    }

    return (
      <div className="home-banner-wrap col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div className="box-image">
          {Img}
        </div>
        <div className="box-content">
          <h4 className="heading-4">
            <a href={this.props.data.link} target="_blank" title={this.props.data.link} className="banner-link">{this.props.data.link}</a>
          </h4>
        </div>
        <div className="box-action">
          <button className="btn btn-default" onClick={this.goEdit}>Sửa</button>
          <button className="btn btn-danger" onClick={this.handleDelete}>Xóa</button>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(HomeBannerBox));



// WEBPACK FOOTER //
// ./components/home-banners/HomeBannerBox.jsx